export enum ActionType {
  All = "All",
  BmUnits = "BM Units",
  BsadActions = "BSAD actions",
}
